import { render, staticRenderFns } from "./StorageAreas.vue?vue&type=template&id=cd13e07e&scoped=true&"
import script from "./StorageAreas.vue?vue&type=script&lang=js&"
export * from "./StorageAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13e07e",
  null
  
)

export default component.exports